import React from 'react';
import styles from './RadioGroup.module.scss';
import { SelectOption } from '../../types';
import Radio from '../radio/Radio';

type Props = {
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  name: string;
  hasError?: boolean;
  subTitle?: string;
  touchable?: boolean;
  needSpeak?: boolean;
  style?: object;
  isAU?: boolean;
};

function RadioGroup(props: Props) {
  const { options, name, value, onChange, hasError, subTitle, touchable, needSpeak, style, isAU } = props;

  const handleChange = (o: SelectOption) => (value: boolean) => {
    onChange(o.value);
  };

  return (
    <>
      <div className={hasError ? styles.hasError : ''} style={style || {}}>
        {options.map(o => {
          const selected = o.value === value;
          return (
            <Radio key={o.value} id={o.value} checked={selected} label={o.label} onChange={handleChange(o)} name={name} touchable={touchable} needSpeak={needSpeak} isAU={isAU} />
          );
        })}
      </div>
      {subTitle && <div className={hasError ? styles.subErrortitle : styles.subtitle}>{subTitle}</div>}
    </>
  );
}

export default RadioGroup;
